import { render } from "./sobs.vue?vue&type=template&id=62bb81e2"
import script from "./sobs.vue?vue&type=script&lang=js"
export * from "./sobs.vue?vue&type=script&lang=js"

import "./sobs.vue?vue&type=style&index=0&id=62bb81e2&lang=css"
script.render = render

export default script